module.exports = __webpack_public_path__ + "img/digicampus-white-small-high.74f86e70.png";